import { HTML_BLOCK_ELEMENTS_SELECTOR } from './constants/html.constants';

export function stripHtml(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  // DOMParser builds an inert document, so markup in the value is never executed.
  const document = new DOMParser().parseFromString(value, 'text/html');
  // Keep words in separate paragraphs or list items from running together.
  document.body.querySelectorAll(HTML_BLOCK_ELEMENTS_SELECTOR).forEach((element) => element.after(' '));
  return (document.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}
